module.exports = __webpack_public_path__ + "img/pipedrive.e2920ef3.png";